import {
  BaseVO,
  streamId,
  StreamId,
  streamName,
  StreamName
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class MixerVideoStreamVO extends BaseVO<MixerVideStream> {
  private static validation = JsonSchemaValidator.compile(
    MixerVideoStreamVO.validationSchema()
  );

  constructor(value: MixerVideStream) {
    super(JsonSchemaValidator.assert(MixerVideoStreamVO.validation, value));
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["streamId", "streamName"],
      properties: {
        streamId,
        streamName
      },
      additionalProperties: false
    };
  }
}

interface MixerVideStream {
  streamId: StreamId;
  streamName: StreamName;
}
